export default "__VITE_ASSET__0CHOv8zz__"